import React from 'react';
import Link from 'Pure/Link';
import { isTrue } from 'Shared/utilities';
const {
  moment
} = window;
export default function DiscountCodeRow(props) {
  const {
    data,
    blank = false,
    fields
  } = props;
  const href = (document.location.pathname + '/' + data.id).replace('//', '/');
  const link = /*#__PURE__*/React.createElement(Link, {
    className: "u-link-only",
    href: href
  }, "Modifier le code promo");
  const myWO_count = data.establishments?.length || 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell DiscountCode-code"
  }, data.code, link), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell DiscountCode-start"
  }, moment(data.start).format('DD/MM/YYYY'), ' - ', moment(data.end).format('DD/MM/YYYY'), link), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell DiscountCode-booking_start"
  }, moment(data.booking_start).format('DD/MM/YYYY'), ' - ', moment(data.booking_end).format('DD/MM/YYYY'), link), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell DiscountCode-offered_hours"
  }, isTrue(data.percent_discount) ? (data.percent || '0') + '%' : (data.offered_hours || '0') + 'h', link), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell DiscountCode-max_use"
  }, data.max_use, link), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell DiscountCode-type"
  }, data.type === 'myWO' ? myWO_count + ' myWO' : data.postal_code ? 'Les myWO avec un code postal en ' + data.postal_code : data.type === 'excluded_myWO' ? 'Tous les myWO sauf ' + myWO_count : 'Tous les myWO', link), /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell DiscountCode-title"
  }, data.title, link));
}
